/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menureadingdishesone3Inputs */

const en_menureadingdishesone3 = /** @type {(inputs: Menureadingdishesone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 dish recognised`)
};

const de_menureadingdishesone3 = /** @type {(inputs: Menureadingdishesone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Gericht erkannt`)
};

/**
* | output |
* | --- |
* | "1 dish recognised" |
*
* @param {Menureadingdishesone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menureadingdishesone3 = /** @type {((inputs?: Menureadingdishesone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menureadingdishesone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menureadingdishesone3(inputs)
	return de_menureadingdishesone3(inputs)
});
export { menureadingdishesone3 as "menuReadingDishesOne" }